<div class="flex flex-col -m-6">

  <!-- Header -->
  <div class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">{{ 'masterNewInstanceTitle' | transloco }}</div>

    <button mat-icon-button [tabIndex]="-1" (click)="closeDialog()">
      <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="flex flex-row items-center justify-center p-2 pt-8 sm:items-start w-full">
    <mat-form-field class="w-full lg:w-1/2">
      <mat-label>{{ 'selectTipology' | transloco }}</mat-label>
      <mat-select [formControl]="tipologyControl">
        <mat-option [value]="''">{{ 'noSelection' | transloco }}</mat-option>
        @for (option of tipologyOptions; track option) {
          <mat-option [value]="option.code">
            {{ option.value | localize }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex flex-row items-center justify-center p-2 sm:items-start w-full">
    <mat-form-field class="w-full lg:w-1/2">
      <mat-label>{{ 'selectValidity' | transloco }}</mat-label>
      <mat-select [formControl]="validityControl">
        @for (option of validityOptions; track option) {
          <mat-option [value]="option.code">
            {{ option.value | localize }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Actions -->
  <div class="flex flex-row justify-end px-4 pb-2 sm:px-8 sm:pb-4 w-full">
    <button mat-raised-button color="primary" (click)="getNewInstance()">{{ 'create' | transloco }}</button>
  </div>
</div>